import type { RouteObject } from 'react-router';

import type { RouteHandle } from '@/hooks/useRouteHandle';

/** 3문항 체험(specs/070) — 비로그인 공개, 미니멀 레이아웃. */
export const trialRoutes: RouteObject[] = [
  {
    path: 'trial',
    lazy: () => import('./pages/TrialPage').then((m) => ({ Component: m.TrialPage })),
    handle: { title: '우리 회사 지원사업 찾기', pageLabel: '판정 미리보기' } satisfies RouteHandle,
  },
];
